import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Input from "../../../../../../../components/textbox/Input";
import styles from "../SchedaSpecialeArbovirosi.module.css";
import Utils from "../../../../../../../utils/Utils";

class EsamiDiLaboratorio extends Component {
    state = {
        EsamiDiLaboratorio: {
            liquor: { selezionato: "", data: "", tests: { igm: "", igg: "", isolamento: "" } },
            siero: { selezionato: "", data: "", tests: { igm: "", igg: "", neutralizzazione: "", isolamento: "", nat: "", antigene: "" } },
            pcr: { selezionato: "", data: "", tests: { pcr: "" }, campioni: { liquor: false, sieroSangue: false, urine: false } },
            sequenziamento: {
                "WNV-Lineage1": false, "WNV-Lineage2": false, "wnvAltro": false, "wnvAltroSpecificare": "",
                "DENV-1": false, "DENV-2": false, "DENV-3": false, "DENV-4": false
            },
            invioCampione: { scelta: "", data: "" },
            corretto: []
        }
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreCheckbox = this.riceviValoreCheckbox.bind(this);
        this.togglePcrCampione = this.togglePcrCampione.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia?.schedaSpeciale?.esamiDiLaboratorio) {
            const def = this.state.EsamiDiLaboratorio;
            const json = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.esamiDiLaboratorio));
            this.setState({
                EsamiDiLaboratorio: {
                    ...def,
                    ...json,
                    liquor: { ...def.liquor, ...json.liquor, tests: { ...def.liquor.tests, ...(json.liquor?.tests || {}) } },
                    siero:  { ...def.siero,  ...json.siero,  tests: { ...def.siero.tests,  ...(json.siero?.tests  || {}) } },
                    pcr:    { ...def.pcr,    ...json.pcr,    tests: { ...def.pcr.tests, ...(json.pcr?.tests || {}) }, campioni: { ...def.pcr.campioni, ...(json.pcr?.campioni || {}) } },
                    sequenziamento: { ...def.sequenziamento, ...(json.sequenziamento || {}) },
                    invioCampione:  { ...def.invioCampione,  ...(json.invioCampione  || {}) },
                    corretto: []
                }
            }, () => this.aggiornaPadre());
        } else if (this.props.segnalazioneCopia.infoLaboratorio) {
            const infoLab = this.props.segnalazioneCopia.infoLaboratorio;
            const lista = Array.isArray(infoLab.listaDettaglioLab) ? infoLab.listaDettaglioLab : [];
            const dataPrelievo = infoLab.dataPrelievo ? Utils.formatDateISO(infoLab.dataPrelievo, "/") : "";
            const dataEsame    = infoLab.dataEsame    ? Utils.formatDateISO(infoLab.dataEsame,    "/") : "";
            const isLRR        = infoLab.tipoLaboratorio === "R";

            // Mappa codice → lista di azioni di prevalorizzazione.
            // Ogni azione ha sezione + uno tra:
            //   - test:     setta nuovoStato[sezione].tests[test] = "1" (Pos); +selezionato="Si", +data
            //   - campione: setta nuovoStato[sezione].campioni[campione] = true (per PCR); +selezionato="Si", +data
            //   - flag:     setta nuovoStato[sezione][flag] = true (per sequenziamento, no selezionato, no data)
            //   - nulla:    solo nuovoStato[sezione].selezionato = "Si" + data (es. PCR solo "Si" senza campione)
            const mappaPrevalorizzazione = {
                // ── LIQUOR ──
                "33":  [{ sez: "liquor", test: "igm" }],
                "157": [{ sez: "liquor", test: "igm" }, { sez: "siero", test: "igm" }],
                "158": [{ sez: "liquor", test: "igm" }],
                "159": [{ sez: "liquor", test: "igm" }],
                "339": [{ sez: "liquor", test: "igm" }],
                "347": [{ sez: "liquor", test: "igm" }],
                "321": [{ sez: "liquor", test: "igg" }],
                "27":  [{ sez: "liquor", test: "isolamento" }],
                "335": [{ sez: "liquor", test: "isolamento" }],
                "341": [{ sez: "liquor", test: "isolamento" }],
                // ── SIERO / SANGUE ──
                "249": [{ sez: "siero", test: "igm" }],
                "351": [{ sez: "siero", test: "igm" }, { sez: "siero", test: "igg" }, { sez: "siero", test: "neutralizzazione" }],
                "272": [{ sez: "siero", test: "igm" }, { sez: "siero", test: "neutralizzazione" }],
                "273": [{ sez: "siero", test: "igm" }],
                "348": [{ sez: "siero", test: "igm" }, { sez: "siero", test: "igg" }],
                "155": [{ sez: "siero", test: "igm" }],
                "252": [{ sez: "siero", test: "igm" }, { sez: "siero", test: "neutralizzazione" }],
                "340": [{ sez: "siero", test: "igm" }, { sez: "siero", test: "igg" }, { sez: "siero", test: "neutralizzazione" }],
                "258": [{ sez: "siero", test: "igm" }],
                "331": [{ sez: "siero", test: "igm" }],
                "156": [{ sez: "siero", test: "igm" }],
                "332": [{ sez: "siero", test: "igm" }],
                "254": [{ sez: "siero", test: "igg" }],
                "259": [{ sez: "siero", test: "igg" }],
                "68":  [{ sez: "siero", test: "igg" }],
                "320": [{ sez: "siero", test: "igg" }],
                "317": [{ sez: "siero", test: "neutralizzazione" }],
                "319": [{ sez: "siero", test: "neutralizzazione" }],
                "342": [{ sez: "siero", test: "isolamento" }],
                "23":  [{ sez: "siero", test: "isolamento" }],
                "26":  [{ sez: "siero", test: "isolamento" }],
                "333": [{ sez: "siero", test: "isolamento" }],
                "253": [{ sez: "siero", test: "antigene" }],
                // ── PCR ──
                "12":  [{ sez: "pcr" }],
                "15":  [{ sez: "pcr", campione: "liquor" }],
                "322": [{ sez: "pcr", campione: "liquor" }],
                "324": [{ sez: "pcr", campione: "liquor" }],
                "326": [{ sez: "pcr", campione: "liquor" }],
                "338": [{ sez: "pcr", campione: "liquor" }],
                "344": [{ sez: "pcr", campione: "liquor" }],
                "14":  [{ sez: "pcr", campione: "sieroSangue" }],
                "323": [{ sez: "pcr", campione: "sieroSangue" }],
                "325": [{ sez: "pcr", campione: "sieroSangue" }],
                "327": [{ sez: "pcr", campione: "sieroSangue" }],
                "336": [{ sez: "pcr", campione: "sieroSangue" }],
                "345": [{ sez: "pcr", campione: "sieroSangue" }],
                "306": [{ sez: "pcr", campione: "urine" }],
                "337": [{ sez: "pcr", campione: "urine" }],
                "346": [{ sez: "pcr", campione: "urine" }],
                // ── SEQUENZIAMENTO ──
                // 434-437: DENV-X + PCR=Si (con data, senza campione)
                "434": [{ sez: "sequenziamento", flag: "DENV-1" }, { sez: "pcr" }],
                "435": [{ sez: "sequenziamento", flag: "DENV-2" }, { sez: "pcr" }],
                "436": [{ sez: "sequenziamento", flag: "DENV-3" }, { sez: "pcr" }],
                "437": [{ sez: "sequenziamento", flag: "DENV-4" }, { sez: "pcr" }],
                // 438-441: DENV-X + Siero/Sangue Isolamento virale (implica siero=Si + data)
                "438": [{ sez: "sequenziamento", flag: "DENV-1" }, { sez: "siero", test: "isolamento" }],
                "439": [{ sez: "sequenziamento", flag: "DENV-2" }, { sez: "siero", test: "isolamento" }],
                "440": [{ sez: "sequenziamento", flag: "DENV-3" }, { sez: "siero", test: "isolamento" }],
                "441": [{ sez: "sequenziamento", flag: "DENV-4" }, { sez: "siero", test: "isolamento" }]
            };

            this.setState(prev => {
                const nuovoStato = JSON.parse(JSON.stringify(prev.EsamiDiLaboratorio));
                const sezioniToccate = new Set();

                lista.forEach(codice => {
                    const azioni = mappaPrevalorizzazione[codice];
                    if (!azioni) return;
                    azioni.forEach(({ sez, test, campione, flag }) => {
                        if (flag) {
                            // Sezione di soli flag booleani (es. sequenziamento): no selezionato, no data
                            nuovoStato[sez][flag] = true;
                            return;
                        }
                        nuovoStato[sez].selezionato = "Si";
                        if (test) nuovoStato[sez].tests[test] = "1";
                        if (campione) nuovoStato[sez].campioni[campione] = true;
                        sezioniToccate.add(sez);
                    });
                });

                // Prevalorizza pcr.tests.pcr a "Pos" se almeno un campione PCR è flaggato dalla mappa
                const c = nuovoStato.pcr.campioni;
                if (c.liquor || c.sieroSangue || c.urine) {
                    nuovoStato.pcr.tests.pcr = "1";
                }

                if (dataPrelievo) {
                    sezioniToccate.forEach(sez => { nuovoStato[sez].data = dataPrelievo; });
                }

                // Invio campione al LRR: se laboratorio è tipo "R" (LRR), pre-seleziona "Si" e data esame
                if (isLRR) {
                    nuovoStato.invioCampione.scelta = "Si";
                    if (dataEsame) nuovoStato.invioCampione.data = dataEsame;
                }

                return { EsamiDiLaboratorio: nuovoStato };
            }, () => this.aggiornaPadre());
        } else {
            this.aggiornaPadre();
        }
    }

    riceviValore(campoTarget, valoreGrezzo) {
        let v = (valoreGrezzo && valoreGrezzo.target) ? valoreGrezzo.target.value : valoreGrezzo;

        this.setState(prevState => {
            let nuovoStato = JSON.parse(JSON.stringify(prevState.EsamiDiLaboratorio));

            if (campoTarget === "wnvAltroSpecificare") {
                nuovoStato.sequenziamento.wnvAltroSpecificare = v;
            } else if (campoTarget.endsWith("_sel")) {
                const sez = campoTarget.split("_")[0];
                nuovoStato[sez].selezionato = v;
                if (v !== "Si") {
                    nuovoStato[sez].data = "";
                    if (nuovoStato[sez].tests) {
                        Object.keys(nuovoStato[sez].tests).forEach(k => nuovoStato[sez].tests[k] = "");
                    }
                    if (nuovoStato[sez].campioni) {
                        Object.keys(nuovoStato[sez].campioni).forEach(k => nuovoStato[sez].campioni[k] = false);
                    }
                }
            } else if (campoTarget.includes("_")) {
                const [sez, sub] = campoTarget.split("_");
                if (sub === "data") nuovoStato[sez].data = v;
                else nuovoStato[sez].tests[sub] = v;
            } else if (campoTarget === "sceltaInvio" || campoTarget === "dataInvio") {
                if (campoTarget === "sceltaInvio") {
                    nuovoStato.invioCampione.scelta = v;
                    if (v !== "Si") nuovoStato.invioCampione.data = "";
                } else {
                    nuovoStato.invioCampione.data = v;
                }
            }

            return { EsamiDiLaboratorio: nuovoStato };
        }, () => this.aggiornaPadre());
    }

    riceviValoreCheckbox(campoTarget, nuovoValore) {
        this.setState(prevState => {
            let nuovoStato = JSON.parse(JSON.stringify(prevState.EsamiDiLaboratorio));
            nuovoStato.sequenziamento[campoTarget] = nuovoValore;
            if (campoTarget === "wnvAltro" && !nuovoValore) {
                nuovoStato.sequenziamento.wnvAltroSpecificare = "";
            }
            return { EsamiDiLaboratorio: nuovoStato };
        }, () => this.aggiornaPadre());
    }

    togglePcrCampione(campione) {
        this.setState(prevState => {
            let nuovoStato = JSON.parse(JSON.stringify(prevState.EsamiDiLaboratorio));
            nuovoStato.pcr.campioni[campione] = !nuovoStato.pcr.campioni[campione];
            return { EsamiDiLaboratorio: nuovoStato };
        }, () => this.aggiornaPadre());
    }

    // ─────────────────────────────────────────────
    // AGGIUNTO: Validazione campi obbligatori (*)
    // ─────────────────────────────────────────────
    controlloCorrettezza() {
        let dati = this.state.EsamiDiLaboratorio;
        dati.corretto = [];

        if (!dati.liquor.selezionato)
            dati.corretto[0] = "Campo Liquor obbligatorio";

        if (!dati.siero.selezionato)
            dati.corretto[1] = "Campo Siero / Sangue obbligatorio";

        if (!dati.pcr.selezionato) {
            dati.corretto[2] = "Campo PCR obbligatorio";
        } else if (
            dati.pcr.selezionato === "Si"
            && !dati.pcr.campioni.liquor
            && !dati.pcr.campioni.sieroSangue
            && !dati.pcr.campioni.urine
        ) {
            dati.corretto[2] = "Selezionare almeno un campione PCR (Liquor, Siero/Sangue o Urine)";
        }

        if (!dati.invioCampione.scelta)
            dati.corretto[3] = "Campo Invio campione al LRR obbligatorio";
    }

    // ─────────────────────────────────────────────
    // AGGIUNTO: Costruisce oggetto pulito per il BE
    // ─────────────────────────────────────────────
    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.EsamiDiLaboratorio));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");  // ← non inviare corretto al BE
    }

    aggiornaPadre() {
        this.controlloCorrettezza();  // ← AGGIUNTO: valida prima di notificare il padre

        // ← AGGIUNTO: notifica il padre della validazione (come in classificazioneDelCaso)
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();

        let oggettoBE = this.createOggettoBE();  // ← MODIFICATO: usa createOggettoBE

        if (this.props.setEsamiDiLaboratorio) {
            this.props.setEsamiDiLaboratorio(this.state.EsamiDiLaboratorio, oggettoBE);
        }
    }

    renderTestRow(sezione, label, field) {
        const dataSez = this.state.EsamiDiLaboratorio[sezione];
        const isEnabled = dataSez.selezionato === "Si";

        return (
            <div className="row mb-1 align-items-center" style={{ opacity: isEnabled ? 1 : 0.5 }}>
                <div className="col-lg-3 offset-lg-1">
                    <span style={{ color: "black", fontWeight: "600" }}>{label}</span>
                </div>
                {["1", "2", "3"].map(val => (
                    <div className="col-lg-2" key={`${sezione}_${field}_${val}`}>
                        <RadioButton
                            id={`rb_${sezione}_${field}_${val}`}
                            label={val === "1" ? "Pos" : val === "2" ? "Neg" : "Dubbio"}
                            value={val}
                            checked={isEnabled && dataSez.tests[field] === val}
                            onClick={() => this.riceviValore(`${sezione}_${field}`, dataSez.tests[field] === val ? "" : val)}
                            disabled={!isEnabled}
                            newRadio={true}
                        />
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const { EsamiDiLaboratorio: data } = this.state;
        const listaSequenziamento = ["WNV-Lineage1", "WNV-Lineage2", "DENV-1", "DENV-2", "DENV-3", "DENV-4"];

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>

                {/* --- LIQUOR --- */}
                <div className="row mt-4 align-items-center">
                    <div className="col-lg-3"><b>Liquor <span style={{color: "red"}}>*</span></b></div>
                    <div className="col-lg-4 d-flex">
                        {["Si", "No", "Non noto"].map(l => (
                            <RadioButton key={l} id={`liq_${l}`} label={l} value={l}
                                checked={data.liquor.selezionato === l}
                                onClick={() => this.riceviValore("liquor_sel", l)} newRadio={true} />
                        ))}
                    </div>
                    <div className="col-lg-5">
                        <p style={{ fontWeight: "bold", fontSize: "15px", color: "#1b7ea9" }}>
                            Data prelievo del campione
                        </p>
                        <Calendar id="cal_liq" value={data.liquor.data}
                            onChange={(v) => this.riceviValore("liquor_data", v)}
                            disabled={data.liquor.selezionato !== "Si"} />
                    </div>
                </div>
                {this.renderTestRow("liquor", "IgM", "igm")}
                {this.renderTestRow("liquor", "IgG", "igg")}
                {this.renderTestRow("liquor", "Isolamento virale", "isolamento")}

                <div className="row mt-4 align-items-center">
                    <div className="col-lg-3"><b>Siero / Sangue <span style={{color: "red"}}>*</span></b></div>
                    <div className="col-lg-4 d-flex">
                        {["Si", "No", "Non noto"].map(l => (
                            <RadioButton key={l} id={`sie_${l}`} label={l} value={l}
                                checked={data.siero.selezionato === l}
                                onClick={() => this.riceviValore("siero_sel", l)} newRadio={true} />
                        ))}
                    </div>
                    <div className="col-lg-5">
                        <p style={{ fontWeight: "bold", fontSize: "15px", color: "#1b7ea9" }}>
                            Data prelievo del campione
                        </p>
                        <Calendar id="cal_sie" value={data.siero.data}
                            onChange={(v) => this.riceviValore("siero_data", v)}
                            disabled={data.siero.selezionato !== "Si"} />
                    </div>
                </div>
                {this.renderTestRow("siero", "IgM", "igm")}
                {this.renderTestRow("siero", "IgG", "igg")}
                {this.renderTestRow("siero", "Test di neutralizzazione", "neutralizzazione")}
                {this.renderTestRow("siero", "Isolamento Virale", "isolamento")}
                {this.renderTestRow("siero", "Test NAT", "nat")}
                {this.renderTestRow("siero", "Identificazione antigene", "antigene")}

                {/* --- PCR --- */}
                <div className="row mt-4 align-items-center">
                    <div className="col-lg-3"><b>PCR <span style={{color: "red"}}>*</span></b></div>
                    <div className="col-lg-4 d-flex">
                        {["Si", "No", "Non noto"].map(l => (
                            <RadioButton key={l} id={`pcr_${l}`} label={l} value={l}
                                checked={data.pcr.selezionato === l}
                                onClick={() => this.riceviValore("pcr_sel", l)} newRadio={true} />
                        ))}
                    </div>
                    <div className="col-lg-5">
                        <p style={{ fontWeight: "bold", fontSize: "15px", color: "#1b7ea9" }}>
                            Data prelievo del campione
                        </p>
                        <Calendar id="cal_pcr" value={data.pcr.data}
                            onChange={(v) => this.riceviValore("pcr_data", v)}
                            disabled={data.pcr.selezionato !== "Si"} />
                    </div>
                </div>
                {this.renderTestRow("pcr", "PCR", "pcr")}
                <div className="row mb-1 mt-2 align-items-center" style={{ opacity: data.pcr.selezionato === "Si" ? 1 : 0.5 }}>
                    <div className="col-lg-3 offset-lg-1">
                        <span style={{ color: "black", fontWeight: "600" }}>Campioni{data.pcr.selezionato === "Si" && <span style={{color: "red"}}>*</span>}</span>
                    </div>
                    <div className="col-lg-7">
                        <div className="row">
                            {[
                                { key: "liquor", label: "Liquor" },
                                { key: "sieroSangue", label: "Siero / Sangue" },
                                { key: "urine", label: "Urine" }
                            ].map(c => (
                                <div className="col-lg-4 mb-2" key={c.key}>
                                    <CheckBox
                                        id={`pcr_campione_${c.key}`}
                                        text={c.label}
                                        checked={data.pcr.campioni[c.key]}
                                        onChange={() => this.togglePcrCampione(c.key)}
                                        disabledFlag={data.pcr.selezionato !== "Si"}
                                        newCheckbox={true}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-3"><b>Sequenziamento</b></div>
                    <div className="col-lg-9">
                        <div className="row">
                            {listaSequenziamento.map(item => (
                                <div className="col-lg-4 mb-2" key={item}>
                                    <CheckBox
                                        id={item} text={item}
                                        checked={data.sequenziamento[item]}
                                        onChange={() => this.riceviValoreCheckbox(item, !data.sequenziamento[item])}
                                        newCheckbox={true}
                                    />
                                </div>
                            ))}
                            <div className="col-lg-4 d-flex align-items-center mb-2">
                                <CheckBox
                                    text="Altro"
                                    checked={data.sequenziamento.wnvAltro}
                                    onChange={() => this.riceviValoreCheckbox("wnvAltro", !data.sequenziamento.wnvAltro)}
                                    newCheckbox={true}
                                />
                                <div style={{ marginLeft: "10px", flexGrow: 1 }}>
                                    <Input
                                        value={data.sequenziamento.wnvAltroSpecificare}
                                        onChange={(field, v) => this.riceviValore("wnvAltroSpecificare", v)}
                                        disabled={!data.sequenziamento.wnvAltro}
                                        placeholder="Specificare"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4 mb-5 align-items-center">
                    <div className="col-lg-4"><b>Invio del campione al Laboratorio presso LRR <span style={{color: "red"}}>*</span></b></div>
                    <div className="col-lg-3 d-flex">
                        {["Si", "No"].map(l => (
                            <RadioButton key={l} id={`inv_${l}`} label={l} value={l}
                                checked={data.invioCampione.scelta === l}
                                onClick={() => this.riceviValore("sceltaInvio", l)} newRadio={true} />
                        ))}
                    </div>
                    <div className="col-lg-5">
                        <p style={{ fontWeight: "bold", fontSize: "15px", color: "#1b7ea9" }}>
                            Se sì, data di invio
                        </p>
                        <Calendar id="cal_inv" value={data.invioCampione.data}
                            onChange={(v) => this.riceviValore("dataInvio", v)}
                            disabled={data.invioCampione.scelta !== "Si"} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(EsamiDiLaboratorio);